import axiosInstance from '../config/axiosInstance';

export const fetchDomains = async () => {
  try {
    const response = await axiosInstance.get('/domains/list');
    if (response.data.success) {
      return response.data.data.map(domain => ({
        value: domain.code,
        label: `${domain.code} (${domain.domain})`
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching domains:', error);
    return [];
  }
};
